import isDefined from './isDefined';
import isFunc from './isFunc';

export default function (obj) {
    if (!isDefined(obj)) return false;

    return isFunc(obj.then) && isFunc(obj.catch);
}